import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import map from 'lodash/map';
import omit from 'lodash/omit';
import pull from 'lodash/pull';

import omitBy from 'lodash/omitBy';
import keys from 'lodash/keys';
import slice from 'lodash/slice';
import isEmpty from 'lodash/isEmpty';

import head from 'lodash/head';
import capitalize from 'lodash/capitalize';

import { normalizeString } from '@dmm/lib-common/lib/formatting';
import { getDefaultParams, getActiveParams, generateSearchPath, hyphenateUrlComponents, unhyphenateUrlComponents } from '../../../../../utils/urlHelpers/engines';
import { toggleSubFacet } from '../../../../../utils/multiFacetHelper';

import { injectIntl } from 'react-intl';

// Stylesheets
import './styles.css';
import { getMessages } from '../../../../../tppServices/translations/messages';

const List = ({ title, link, count, t }) => {
  const messages = getMessages();
  return (
    <div className="related__list_item" key={title}>
      <a href={link} >{title}</a>
      <span>{t(messages.listings, {count})}</span>
    </div>
  );
};

List.propTypes = {
  title: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  t: PropTypes.func.isRequired
};

class RelatedContent extends PureComponent {

  setNoPageType = () => {
    return {
      pageType: ''
    };
  }

  selectMakeOrModelPage = (models) => {
    if (models.length === 1){
      return {
        pageType: 'model',
        pageValue: models[0],
        conditionTitle: capitalize(unhyphenateUrlComponents(models[0]))
      };
    } else if (models.length === 0) {
      return {
        pageType: 'make'
      };
    }
    return this.setNoPageType();
  }

  getPageType(t) {
    const { params } = this.props;
    const messages = getMessages();
    const searchParams = omitBy(params, (value) => {return value === undefined;});
    let selectedParams = keys(searchParams);
    selectedParams = pull(selectedParams, 'make', 'model', 'makeModel', 'category');
    if (selectedParams.length !== 0) {
      // If there is a param selected not related with category, model or make dont show the relatedContent component
      return this.setNoPageType();
    }
    const defaultParams = getDefaultParams(params);
    const currentParams = getActiveParams(defaultParams);
    const makeModel = get(currentParams, 'makeModel', {});
    const category = get(currentParams, 'category', {});
    const makeSelected = !isEmpty(makeModel);
    const categorySelected = !isEmpty(category);
    if (makeSelected && categorySelected){
      return this.setNoPageType();
    } else if (categorySelected) {
      return {
        pageType: 'category',
        pageValue: category,
        conditionTitle: capitalize(t(messages.categoryFacet[category]))
      };
    }
    const makeModelKeys = Object.keys(makeModel);
    if (makeModelKeys.length === 1){
      // only one make selected
      const models = makeModel[makeModelKeys[0]];
      return this.selectMakeOrModelPage(models);
    }
    return this.setNoPageType();
  }

  renderConditionListItem = (condition, make, contentOptions, t) => {
    const title = get(condition, 'value', '');
    const count = get(condition, 'count', '');
    const messages = getMessages();

    const conditionTranslation = t(messages.relatedContent.engines.listingConditions[title]);
    const typeTanslation = contentOptions.conditionTitle;
    const listingConditionMessage = contentOptions.pageType === 'model' ?
      messages.relatedContent.engines.listingConditionMake :
      messages.relatedContent.engines.listingCondition;

    return (
      <div className="related__list_item" key={title}>
        <div>
          {t(listingConditionMessage, { condition: conditionTranslation, type: typeTanslation, make })}
        </div>
        <span>{t(messages.listings, { count })}</span>
      </div>
    );
  }

  render () {
    const { facets, params, intl: { formatMessage: t } } = this.props;
    const messages = getMessages();
    const defaultParams = getDefaultParams(params);
    let contentOptions = this.getPageType(t);
    if (contentOptions.pageType === 'make') {
      const makeModel = get(facets, 'makeModel', { value: ''});
      const allModels = head(makeModel);
      const title = omit(allModels, ['count', 'model']);
      const make = get(title, 'value', '');
      if (make !== 'other'){
        contentOptions.pageValue = make;
        contentOptions.conditionTitle = make;
      } else {
        contentOptions.pageType = '';
      }
    }
    const makeModel = get(facets, 'makeModel', { value: ''});
    const conditions = get(facets, 'condition', {});
    const allModels = head(makeModel);
    const title = omit(allModels, ['count', 'model']);
    const allMakes = get(facets, 'makeModel', []);
    const makes = allMakes.filter((obj) => obj.value !== 'other').slice(0, 10);
    const models = slice(get(allModels, 'model', []), 0, 10);
    const make = get(title, 'value', '');
    let slugMake = normalizeString(hyphenateUrlComponents(make));
    const enginesMessages = messages.relatedContent.engines;
    let conditionMessage;
    if (contentOptions.pageType === 'model') {
      conditionMessage = t(enginesMessages.headerConditionMake, {
        type: contentOptions.conditionTitle,
        make: make
      });
    }
    else {
      conditionMessage = t(enginesMessages.headerCondition, {
        type: contentOptions.conditionTitle,
        make: make
      });
    }
    return (
      <>
        {
          contentOptions.pageType !== '' &&
          <div className="related__content">
            {
              contentOptions.pageType !== 'category' &&
              conditionMessage &&
              <div className="related__condition">
                <h2 className="by-condition">
                  {`${conditionMessage[0].toUpperCase() + conditionMessage.substring(1)}`}
                </h2>

                {map(conditions, (condition) => this.renderConditionListItem(condition, make, contentOptions, t))}
              </div>
            }
            {
              contentOptions.pageType === 'category' &&
              <div className="related__make">
                <h2 className="by-make">{t(enginesMessages.headerMake, {
                  type: contentOptions.conditionTitle
                })}</h2>

                {map(makes, make => {
                  const title = get(make, 'value', '');
                  let slugMake = normalizeString(hyphenateUrlComponents(title));
                  const count = get(make, 'count', '');
                  const link = generateSearchPath({ 'makeModel': toggleSubFacet(slugMake, '', {}, true) }, {}, true);
                  return (
                    <List
                      key={title}
                      link={link}
                      title={`${title}`}
                      count={count}
                      t={t}
                    />
                  );
                })}
              </div>
            }
            {
              contentOptions.pageType === 'make' &&
              <div className="related__model">
                <h2 className="by-model">{t(enginesMessages.headerModel, {make: make})}</h2>

                {map(models, model => {
                  const title = get(model, 'value', '');
                  let slugModel = hyphenateUrlComponents(title);
                  const count = get(model, 'count', '');
                  const link = generateSearchPath({ 'makeModel': toggleSubFacet(slugMake, slugModel, {}, true) }, defaultParams, true);
                  return (
                    <List
                      key={title}
                      link={link}
                      title={`${make} ${title}`}
                      count={count}
                      t={t}
                    />
                  );
                })}
              </div>
            }
          </div>
        }
      </>
    );
  }
}

RelatedContent.propTypes = {
  facets: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired
};

export default injectIntl(RelatedContent);
